<template>
  <div class="home">
<NavbarSesion/>
<RutinaHero/>
<FooterHero/>

  </div>
</template>

<script>
import NavbarSesion from '@/components/NavbarSesion.vue';
import RutinaHero from '@/components/Rutinas/RutinaHero.vue';
import FooterHero from '@/components/FooterHero.vue';
export default {
  name: 'HomeView',
  components: {
NavbarSesion,
RutinaHero,
FooterHero
  }
}
</script>
